export default "__VITE_ASSET__4e83cdc9__"